module.exports = __webpack_public_path__ + "img/popper_icon.2b07e876.png";